import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import * as JSTool from '../store/JSTool';
import { settingActions, settingObj } from '../store/SettingSlice';
import { blueGrey } from '@mui/material/colors';

export default function Page0(props) {
    const settingData = useSelector(state => state.settingData);
    const dispatch = useDispatch();

    React.useEffect(() => {

    }, []);

    return (
        <Stack sx={{
            width: 1,
            height: settingData.height,
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
        }}>
            <Box
                component={'video'}
                autoPlay={true}
                loop={true}
                muted={true}
                playsInline={true}
                disablePictureInPicture={true}
                poster={settingData.isMobile ? JSTool.getImgPath('kv.webp') : JSTool.getImgPath('kv.webp')}
                src={JSTool.getImgPath('home_v_2.mp4')}
                sx={{
                    width: 1,
                    height: 1,
                    objectFit: 'cover',
                }} />

            <Stack sx={{
                zIndex: 2,
                position: 'absolute',
                width: 1,
                height: 1,
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <Stack sx={{
                    bottom: settingData.isMobile ? '160rem' : '110rem',
                    position: 'absolute',
                    left: !settingData.isMobile && '100rem',
                    alignItems: settingData.isMobile && 'center',
                }}>

                    <Box component={'img'}
                        src={JSTool.getImgPath('logo_white2.png')}
                        sx={{
                            height: settingData.isMobile ? '80rem' : '130rem',
                        }} />


                    <Stack sx={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mt: 6,
                    }}>

                        <Typography
                            onClick={() => {
                                dispatch(settingActions.showRegisterAlert(true));
                            }}
                            sx={{

                                width: settingData.isMobile ? '220rem' : '250rem',
                                height: '55rem',
                                lineHeight: '55rem',
                                fontSize: '18rem',
                                fontWeight: 'bold',
                                color: 'white',
                                cursor: 'pointer',
                                textAlign: 'center',
                                backgroundImage: `url(${JSTool.getImgPath('home_register3.png')})`,
                                backgroundSize: '100% 100%',
                                transitionDuration: '0.3s',
                                fontFamily: window.font0,
                                pb: '5rem',
                                '&:hover': {
                                    transform: 'scale(1.02)',
                                }
                            }}>
                            Pre-register Now
                        </Typography>

                        <Stack
                            sx={{
                                ml: 2,
                                width: settingData.isMobile ? '220rem' : '250rem',
                                height: '60rem',
                                backgroundImage: `url(${JSTool.getImgPath('wish_bg.png')})`,
                                backgroundSize: '100% 100%',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexDirection: 'row',
                                position: 'relative',
                            }}>

                            <Box
                                onClick={() => {
                                    window.open('https://store.steampowered.com/app/3681810/Blue_Protocol_Star_Resonance');
                                }}
                                component={'img'}
                                src={JSTool.getImgPath('steam.png')}
                                sx={{
                                    height: 0.75,
                                    cursor: 'pointer',
                                    transitionDuration: '0.3s',
                                    '&:hover': {
                                        transform: 'scale(1.1)',
                                    }
                                }} />

                            <Box
                                onClick={() => {
                                    window.open('https://store.epicgames.com/p/blue-protocol-star-resonance-27bff9');
                                }}
                                component={'img'}
                                src={JSTool.getImgPath('epic.png')}
                                sx={{
                                    height: 0.75,
                                    ml: 5,
                                    cursor: 'pointer',
                                    transitionDuration: '0.3s',
                                    '&:hover': {
                                        transform: 'scale(1.1)',
                                    }
                                }} />

                            <Box component={'img'}
                                src={JSTool.getImgPath('wish.png')}
                                sx={{
                                    animation: 'scrollerAni 2s ease-in-out both infinite',
                                    height: '25rem',
                                    position: 'absolute',
                                    top: '-30rem',
                                }} />

                        </Stack>

                    </Stack>

                </Stack>
            </Stack>

        </Stack>
    );

}